import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17c',
  url: 'https://17c.com',
  description: '17c是您不可错过的核心体验平台，集内容管理、数据分析、团队协作为一体。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://17c.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17c',
  url: 'https://17c.com',
  description: '17c - 核心数字体验平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-17C1',
    contactType: 'customer service',
    email: 'support@17c.com',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="17c官方落地页 - 探索17c的全部可能"
        description="17c是您不可错过的核心体验平台。本页深度解析17c的功能、优势与使用场景，帮助您快速了解17c能为您带来什么价值，立即探索17c的全方位服务与内容。"
        keywords="17c,17c官网,17c平台,17c使用教程,17c功能介绍,17c最新版本,17c用户指南"
        canonicalUrl="/"
        schemaJson={{ ...homeSchema, ...orgSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <FeaturesSection />
        <CategoriesSection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}